import { COMPANY_VIEW } from '@/fixtures'

export default {
  path: 'company',
  component: () => import('@/views/Route'),
  children: [
    {
      path: '',
      name: 'Company',
      component: () => import('@/views/menus/Company/Index'),
      meta: {
        permission: COMPANY_VIEW
      }
    }
  ]
}
